
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";

export default {
  name: "app-visualizacao-banco",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: { mask },
  components: {},
  data() {
    return {
      allStatus: [],
      data: [],
      labels: [],
      title: null,
    };
  },
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),

    tableItems() {
      const movimentacoes = this.data;
      const tableData = [];
      let lastDate = null;
      let saldoTotal = 0;

      movimentacoes.forEach((mov, index) => {
        const valorMov = Number(mov.valor_movimento) || 0;

        if (lastDate !== mov.data_movimento) {
          if (index === 0) {
            saldoTotal = Number(mov.saldo_dia_anterior) || 0;
          }
          tableData.push({
            descricao: "",
            valor_movimento: saldoTotal,
            data_movimento: "",
            tipo_movimento: null,
            data_saldo_dia_anterior: mov.data_saldo_dia_anterior,
            isSaldoAnterior: true,
          });
        }

        tableData.push({
          ...mov,
          saldo_dia_anterior: null,
          data_saldo_dia_anterior: null,
        });

        saldoTotal += mov.tipo_movimento === 1 ? valorMov : -valorMov;
        lastDate = mov.data_movimento;
      });

      if (movimentacoes.length > 0) {
        const lastMov = movimentacoes[movimentacoes.length - 1];
        tableData.push({
          descricao: "Saldo Final",
          valor_movimento: saldoTotal,
          data_movimento: "",
          tipo_movimento: null,
          data_saldo_dia_anterior: lastMov.data_movimento,
          isSaldoAnterior: true,
        });
      }

      return tableData;
    },

    // Alinha cabeçalho e células da coluna de valores à direita
    cleanLabels() {
      const base = this.labels
        .filter((l) => l.key !== "acoes")
        .map((f) => ({ ...f }));
      const iValor = base.findIndex((l) => l.key === "valor_movimento");
      if (iValor >= 0) {
        base[iValor].tdClass = (base[iValor].tdClass ? base[iValor].tdClass + " " : "") + "text-right";
        base[iValor].thClass = (base[iValor].thClass ? base[iValor].thClass + " " : "") + "text-right";
      }
      return base;
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getInit() {
      this.data = this.$route.params.data;
      this.labels = this.$route.params.labels;
      this.title = this.$route.params.title;
    },
    printDocument() {
      window.print();
    },
    // Histórico baseado no tipo (1 = Entrada, 2 = Saída)
    getHistorico(item) {
      if (item.isSaldoAnterior) return "";
      if (item.tipo_movimento === 1) return item.historico_conta_receber || "";
      if (item.tipo_movimento === 2) return item.historico_conta_pagar || "";
      return "";
    },
  },
  async mounted() {
    await this.getInit();
  },
};
